import { stringInstructionExtractionRegex } from '@utils/regex';
import { ParsedTextSegment, ParsedTextSegmentType } from '../types/parse-text-types';

/**
 * Matches linebreaks in form of \n, \n\r, <br> and &lt;br&gt; (escaped <br>)
 */
const linebreakRegex = /(?:<br>)|(?:&lt;br&gt;)|(?:\n\r?)/g;

function isIcon(segment: string): boolean {
  return segment.startsWith('{{') && segment.endsWith('}}') && segment[2] !== '{' && segment.at(-3) !== '}';
}

/** Breaks up text into icon- and non-icon-segments */
function* parseIcons(text: string): IterableIterator<string> {
  const matches = [...text.matchAll(stringInstructionExtractionRegex)];

  if (matches.length === 0) {
    return yield text;
  }

  for (const match of matches) {
    // Skip first group because it is all the matched segements
    for (let i = 1; i < match.length; i++) {
      const segment = match[i];
      if (!segment) {
        continue;
      }

      yield segment;
    }
  }
}

function* parseLinebreaks(text: string): IterableIterator<ParsedTextSegment> {
  const splits = text.split(linebreakRegex);

  for (let i = 0; i < splits.length; i++) {
    if (i > 0) {
      yield { type: ParsedTextSegmentType.LINEBREAK, value: '' };
    }
    if (splits[i]) {
      yield { type: ParsedTextSegmentType.TEXT, value: splits[i] };
    }
  }
}

export function* parseText(text: string): IterableIterator<ParsedTextSegment> {
  if (!text) {
    return;
  }

  for (const segment of parseIcons(text)) {
    if (isIcon(segment)) {
      yield { type: ParsedTextSegmentType.ICON, value: segment.substring(2, segment.length - 2) };
    } else {
      yield* parseLinebreaks(segment);
    }
  }
}
